import React, { useContext } from "react";
import { TranslatorContext } from "../context/Translator";

export default function FileUploadComponent({ icon, text, onChange,key }) {
    const { t } = useContext(TranslatorContext)

    return (
        <>
            {text ?
                <div className={`mc-file-upload ${ text ? "button" : "icon" }`}>
                    <input type="file" id={key?key:"avatar"} onChange={onChange}/>
                    <label htmlFor={key?key:"avatar"}>
                        <i className="material-icons">{ icon || t('cloud_upload') }</i>
                        <span>{ text || t('upload') }</span>
                    </label>
                </div>
            :
                <div className={`mc-file-upload ${ text ? "button" : "icon" }`}>
                    <input type="file" id={key?key:"avatar"} onChange={onChange}/>
                    <label htmlFor={key?key:"avatar"} className="material-icons">{ icon || t('cloud_upload') }</label>
                </div>
            }
        </>
    )
}


